import styled, { css } from "styled-components";

export const StyledImageUploadWrapper = styled.div`
    display: flex;
    align-items: flex-end;
`;

export const StyledImage = styled.div`
    position: relative;
    width: 127px;
    height: 127px;
    border-radius: 10px;
    border: 1px dashed ${({ theme }) => theme.colors.mediumGrey};
    background-color: ${({ theme }) => theme.colors.lightGrey};
    ${({ imgPreview }) => imgPreview && css`
        border-color: transparent;
        background-color: transparent;
        background-image: url(${imgPreview});
        background-size: contain;
        background-position: center;
        background-repeat: no-repeat;
    `};
`;

export const StyledInputWrapper = styled.div`
    width: 100%;
    height: 100%;
`;

export const StyledInput = styled.input``;

export const StyledImageUpload = styled.div`
    margin-bottom: 20px;
    ${({ disabled }) => disabled && css`
        pointer-events: none;
        opacity: 0.5;
    `};
    ${({ readonly }) => readonly && css`
        pointer-events: none;
        opacity: 0.7;
    `};
    ${({ error }) => error && css`
        ${StyledImage} {
            border: 1px dashed ${({ theme }) => theme.colors.error};
        };
    `};
    ${({ customStyle }) => customStyle && customStyle};
`;